import React from 'react';
export function MaritimeSafety() {
  return <div className="bg-white py-12" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4" data-id="element-170">
        <div className="mb-8" data-id="element-171">
          <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-172">
            Segurança Marítima
          </h2>
          <button className="mt-4 bg-blue-900 text-white px-4 py-2 rounded text-sm font-semibold" data-id="element-173">
            Ver mais
          </button>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-174">
          <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-175">
            <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600" alt="Segurança Marítima" className="w-full h-full object-cover" data-id="element-176" />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-177">
              <h3 className="text-xl font-bold mb-2" data-id="element-178">Vigilância e Segurança</h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-179">
                Explorar
              </button>
            </div>
          </div>
          <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-180">
            <img src="https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=600" alt="Operações Marítimas" className="w-full h-full object-cover" data-id="element-181" />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-182">
              <h3 className="text-xl font-bold mb-2" data-id="element-183">Operações e Salvamento</h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-184">
                Explorar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}